import { serviceRequest } from 'utils/http';
import { StudyService } from 'common/api';

export function getUserStudiesAPI() {
  return serviceRequest(() => StudyService.studyControllerCurrentUserStudies());
}
